/* SHTS Product Page — relocation, delivery date, tabs, sticky ATC */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init() {
    var details = document.querySelector('.product__details--product-page');
    if (!details) return false;

    var atc = document.querySelector('.product__details .add_to_cart');
    if (!atc) return false;

    var formBlock = atc.closest('.product-block');
    if (!formBlock) {
      var n = atc.parentNode;
      while (n && n !== details) {
        if (n.parentNode === details) { formBlock = n; break; }
        n = n.parentNode;
      }
    }
    if (!formBlock) return false;

    /* Badges into gallery */
    var bd = document.getElementById('shts-badges-data');
    if (bd && !document.querySelector('.shts-badges-overlay')) {
      var html = bd.getAttribute('data-badges') || '';
      var gw = document.querySelector('.gallery-wrap');
      if (html && gw) {
        var ov = document.createElement('div');
        ov.className = 'shts-badges-overlay';
        ov.innerHTML = html;
        gw.style.position = 'relative';
        gw.insertBefore(ov, gw.firstChild);
      }
    }

    /* Icons inline with vendor */
    var icons = document.getElementById('shts-icons');
    var vendor = document.querySelector('.product__details p.vendor');
    if (icons && vendor) {
      var vb = vendor.closest('.product-block') || vendor.parentNode;
      if (vb) { vb.classList.add('shts-vendor-row'); vb.appendChild(icons); }
    }

    /* Cards then tabs, after ATC */
    var cursor = formBlock.nextSibling;
    ['shts-cards', 'shts-tabs'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      formBlock.parentNode.insertBefore(el, cursor);
      cursor = el.nextSibling;
    });

    /* Delivery estimate: 2–5 dispatch + 3–7 transit, skipping Sundays */
    var deliv = document.getElementById('shts-deliv');
    var delivLine = document.getElementById('shts-deliv-line');
    if (deliv || delivLine) {
      var M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var biz = function (n) {
        var d = new Date(), c = 0;
        while (c < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) c++; }
        return d;
      };
      var a = biz(5), b = biz(12);
      var range = a.getMonth() === b.getMonth()
        ? a.getDate() + ' \u2013 ' + b.getDate() + ' ' + M[b.getMonth()]
        : a.getDate() + ' ' + M[a.getMonth()] + ' \u2013 ' + b.getDate() + ' ' + M[b.getMonth()];
      if (deliv) deliv.textContent = 'By ' + range;
      if (delivLine) delivLine.textContent = 'Estimated delivery by ' + range;
    }

    /* Tabs */
    var tabs = document.querySelectorAll('[data-shts-tab]');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function () {
        var strip = this.parentNode;
        var btns = strip.querySelectorAll('.shts-tb');
        for (var j = 0; j < btns.length; j++) {
          btns[j].classList.remove('shts-tb--on');
          var p = document.getElementById(btns[j].getAttribute('data-shts-tab'));
          if (p) p.classList.remove('shts-tp--on');
        }
        this.classList.add('shts-tb--on');
        var panel = document.getElementById(this.getAttribute('data-shts-tab'));
        if (panel) panel.classList.add('shts-tp--on');
      });
    }

    /* Sticky ATC, mobile */
    var sticky = document.getElementById('shts-sticky-atc');
    var sBtn = document.getElementById('shts-sticky-btn');
    var sPrice = document.getElementById('shts-sticky-price');
    if (sticky) {
      var mob = function () { return window.innerWidth < 860; };
      new IntersectionObserver(function (e) {
        var show = mob() && !e[0].isIntersecting;
        sticky.classList.toggle('shts-sticky-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 }).observe(atc);

      window.addEventListener('resize', function () {
        if (!mob()) sticky.classList.remove('shts-sticky-visible');
      });

      if (sBtn) sBtn.addEventListener('click', function () {
        atc.click();
        var o = sBtn.textContent;
        sBtn.textContent = 'Added \u2713';
        setTimeout(function () { sBtn.textContent = o; }, 1800);
      });

      document.addEventListener('variantChange', function (e) {
        if (e.detail && e.detail.variant && sPrice) {
          var p = e.detail.variant.price;
          sPrice.textContent = (p / 100).toLocaleString('en-IN', {
            style: 'currency', currency: 'INR', minimumFractionDigits: 0
          });
        }
      });
    }

    /* Share */
    var share = document.querySelector('[data-shts-share]');
    if (share) share.addEventListener('click', function () {
      if (navigator.share) navigator.share({ title: document.title, url: location.href });
      else if (navigator.clipboard) navigator.clipboard.writeText(location.href);
    });

    return true;
  }

  ready(function () {
    if (init()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (init() || ++tries > 20) clearInterval(t);
    }, 150);
  });
})();
